angular.module('app').config(activityLogsRouting);

function activityLogsRouting($routeProvider) {
  $routeProvider.when('/activity_logs', {
    pageTitle: 'ACTIVITY_LOGS',
    template: '<activity-log-list></activity-log-list>',
    breadcrumb: {
      label: 'ACCOUNT_SETTINGS',
      parent: 'ng/account_settings',
    },
    accessPermission: 'index_activitylog_both',
    authReq: true,
  });
}

activityLogsRouting.$inject = ['$routeProvider'];
